export default __webpack_public_path__ + "static/media/06.205856fe.jpg";